export const STUDENTLOOKUP_FETCHING = 'STUDENTLOOKUP_FETCHING';
export const STUDENTLOOKUP_FETCH = 'STUDENTLOOKUP_FETCH';
export const STUDENTLOOKUP_FETCH_ERROR = 'STUDENTLOOKUP_FETCH_ERROR';
export const STUDENTLOOKUP_ADD_STUDENT = 'STUDENTLOOKUP_ADD_STUDENT';



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/studentlookup/types.js